import type { QuickFilter } from '../store/ui';

/**
 * Filtros combinaveis do menu "Filtros" da lista. Viram operadores de busca
 * (`is:unread`, `after:`...) somados ao `q` que a lista ja manda, sem mudar a API.
 */
export type Periodo = 'hoje' | '7d' | '30d';

export interface FiltrosDaLista {
  naoLidas: boolean;
  sinalizadas: boolean;
  comAnexo: boolean;
  semResposta: boolean;
  periodo: Periodo | null;
}

export const SEM_FILTROS: FiltrosDaLista = {
  naoLidas: false,
  sinalizadas: false,
  comAnexo: false,
  semResposta: false,
  periodo: null,
};

const DIAS: Record<Periodo, number> = { hoje: 0, '7d': 7, '30d': 30 };

/** Tira o que a aba (ou a barra lateral) ja impoe: o mesmo filtro duas vezes nao soma nada. */
export function filtrosEfetivos(filtros: FiltrosDaLista, filter: QuickFilter): FiltrosDaLista {
  return {
    ...filtros,
    naoLidas: filtros.naoLidas && filter !== 'unread',
    sinalizadas: filtros.sinalizadas && filter !== 'flagged',
    comAnexo: filtros.comAnexo && filter !== 'attachment',
  };
}

export function contarFiltros(filtros: FiltrosDaLista): number {
  const { periodo, ...marcas } = filtros;
  return Object.values(marcas).filter(Boolean).length + (periodo === null ? 0 : 1);
}

/** Data local AAAA-MM-DD, `dias` antes de `agora`. */
function dataLocal(agora: Date, dias: number): string {
  const d = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() - dias);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mm}-${dd}`;
}

/**
 * Operadores dos filtros ja efetivos, separados por espaco ("" sem filtro).
 * shortcut: o servidor le `after:` como 00:00 UTC; em UTC-3 "Hoje" inclui as
 * 3 h finais de ontem. Corrigir se houver cliente fora do Brasil.
 */
export function operadoresDosFiltros(filtros: FiltrosDaLista, agora = new Date()): string {
  const ops: string[] = [];
  if (filtros.naoLidas) ops.push('is:unread');
  if (filtros.sinalizadas) ops.push('is:flagged');
  if (filtros.comAnexo) ops.push('has:attachment');
  if (filtros.semResposta) ops.push('is:unanswered');
  if (filtros.periodo !== null) ops.push(`after:${dataLocal(agora, DIAS[filtros.periodo])}`);
  return ops.join(' ');
}
